const SCALES = [
	'',
	'thousand',
	'million',
	'billion',
	'trillion',
	'quadrillion',
	'quintillion',
	'sextillion',
	'septillion',
	'octillion',
	'nonillion',
	'decillion',
	// Past here only the Lost Lands' longest players go; at their pace the
	// list outlasts the game (10/16 simulation: about 1e41 after a year).
	'undecillion',
	'duodecillion',
	'tredecillion',
	'quattuordecillion',
	'quindecillion',
	'sexdecillion',
	'septendecillion',
	'octodecillion',
	'novemdecillion',
	'vigintillion',
]

/**
 * 950 -> "950", 3.74 -> "3.74", 1234567 -> "1.235 million".
 *
 * Big numbers always show three decimals so a running total does not jitter.
 * Pass `trim` for fixed amounts such as prices: 1200000 -> "1.2 million".
 */
export function formatGold(amount: number, trim = false): string {
	if (!Number.isFinite(amount)) return '∞'
	if (amount < 1_000)
		return Number.isInteger(amount) ? String(amount) : amount.toFixed(2)
	if (amount < 1_000_000) return Math.floor(amount).toLocaleString('en-US')
	const scale = Math.floor(Math.log10(amount) / 3)
	const name = SCALES[scale]
	if (!name) return amount.toExponential(3).replace('+', '')
	const scaled = (amount / 1000 ** scale).toFixed(3)
	return `${trim ? Number(scaled) : scaled} ${name}`
}

/** 0.3 -> "0.3s", 75 -> "1m 15s", 36864 -> "10h 14m". */
export function formatDuration(seconds: number): string {
	if (seconds < 10) return `${seconds.toFixed(1)}s`
	const s = Math.round(seconds)
	const d = Math.floor(s / 86_400)
	const h = Math.floor((s % 86_400) / 3_600)
	const m = Math.floor((s % 3_600) / 60)
	if (d > 0) return `${d}d ${h}h`
	if (h > 0) return `${h}h ${m}m`
	if (m > 0) return `${m}m ${s % 60}s`
	return `${s}s`
}

/** A speed run's time, to the second: "1d 04:13:07", "4:13:07", "13:07". */
export function formatRunTime(seconds: number): string {
	const s = Math.max(0, Math.floor(seconds))
	const d = Math.floor(s / 86_400)
	const h = Math.floor((s % 86_400) / 3_600)
	const m = Math.floor((s % 3_600) / 60)
	const pad = (n: number) => String(n).padStart(2, '0')
	const clock = `${pad(m)}:${pad(s % 60)}`
	if (d > 0) return `${d}d ${pad(h)}:${clock}`
	if (h > 0) return `${h}:${clock}`
	return clock
}
